import './1_root.less';
import './2_base.less';
import './animation.less';
import './hairline.less';

export const styles = () => [
  //
];
